export default __webpack_public_path__ + "static/media/h5template-hover.f6b68592.svg";